import React from 'react';
import { WebBodyText18, WebHeading28 } from '@fintronners/react-ui/src/GlobalStyling/webTypography';
import Image from 'next/image';
import { InfoPrimaryIcon } from '@/assets/icons';
import { Button } from '@/components/common/Button';
import { SheetContent, SheetFooter, SheetTitle } from '@/components/common/Sheet';
import { useSidePanel } from '@/context/SidePanelContext';
import { useAppStore } from '@/stores/app-store';
import { useTranslation } from 'react-i18next';

/**
 * Fixed Income Trade Error Component
 *
 * This component displays an error message when a fixed income trade fails.
 * It provides the user with an option to go back to the previous step and contact support.
 */
export const FixedIncomeTradeError: React.FC = () => {
  const supportEmail = useAppStore((state) => state.tenantSupportEmail);

  const { goBack } = useSidePanel();
  const { t } = useTranslation();

  return (
    <SheetContent>
      <SheetTitle className="sr-only">
        {t('miscScreens.tradeOptions.fixedIncome.tradeError.title')}
      </SheetTitle>

      <div className="flex flex-col items-center gap-7 text-center mt-40">
        <Image alt="Error icon" width={50} height={50} src={InfoPrimaryIcon.src} />

        <WebHeading28.Bold className="text-darkestBlue">
          {t('miscScreens.tradeOptions.fixedIncome.tradeError.heading')}
        </WebHeading28.Bold>

        <WebBodyText18.Regular className="text-grey72">
          {t('miscScreens.tradeOptions.fixedIncome.tradeError.message', { email: supportEmail })}.
        </WebBodyText18.Regular>
      </div>

      <SheetFooter className="text-center mb-5">
        <Button className="w-full" onClick={goBack}>
          {t('common.back')}
        </Button>
      </SheetFooter>
    </SheetContent>
  );
};
